export type ModelPickerModel = {
	id: string;
	provider: string;
};

export type ModelPickerProviderSection<T extends ModelPickerModel> = {
	provider: T["provider"];
	models: T[];
};

export type ModelPickerSections<T extends ModelPickerModel> = {
	recommended: T[];
	providers: ModelPickerProviderSection<T>[];
};

export function buildModelPickerSections<T extends ModelPickerModel>(
	models: readonly T[],
	recommendedModelIds: readonly string[],
	query: string,
	getName: (model: T) => string,
): ModelPickerSections<T> {
	const recommendedIds = new Set(recommendedModelIds);
	const normalizedQuery = query.trim().toLocaleLowerCase();
	const recommended: T[] = [];
	const providerModels = new Map<T["provider"], T[]>();

	for (const model of models) {
		const name = getName(model);
		if (
			normalizedQuery &&
			!`${name} ${model.provider} ${model.id}`
				.toLocaleLowerCase()
				.includes(normalizedQuery)
		) {
			continue;
		}
		if (recommendedIds.has(model.id)) {
			recommended.push(model);
			continue;
		}
		const grouped = providerModels.get(model.provider);
		if (grouped) {
			grouped.push(model);
		} else {
			providerModels.set(model.provider, [model]);
		}
	}

	return {
		recommended,
		providers: [...providerModels].map(([provider, providerModels]) => ({
			provider,
			models: providerModels,
		})),
	};
}
